import setSharedCallback from './setSharedCallback';
import bbtNative from '../bbtNative';
function setShareContent(options) {
    // 从孕育6.5.0之后，用imageUrl设置分享图片，不再支持imageBase64
    // 从孕育7之后某个版本，可以支持分享图片
    if (options.type === 'picture' && !options.imageBase64) {
        throw new Error('分享图片需要传入要分享图片的Base64编码');
    }
    const callback = options && options.onShared;
    if (callback) {
        setSharedCallback(callback);
    }
    let imageUrl = options.imageUrl;
    if (!imageUrl) {
        // 默认取当前页面中第一张图片为分享缩略图，不考虑图片是否可见
        let img = document.querySelector('img[src]:not([src=""])');
        if (img) {
            imageUrl = img.src;
        }
    }
    let share = {};
    // isSame为true时，参数需完全按照原生的参数传入
    if (options.isSame) {
        share = options;
    }
    else {
        share = {
            share_url: options.url ||
                location.href
                    .replace(/&babytree-(?:app|client)-\w+=[\d\w\-.]+/g, '')
                    .replace(/\?babytree-(?:app|client)-\w+=[\d\w\-.]+&/g, '?')
                    .replace(/&bpreg_brithday=[\d\w\-.]+/g, '')
                    .replace(/\?bpreg_brithday=[\d\w\-.]+&/g, '?'),
            share_title: options.title || document.title,
            share_content: options.content || options.title || document.title,
            image_base64: imageUrl,
            onShared: options.onShared
        };
    }
    share.success = function () {
        window.console.log('分享成功，调用window.share.success, 不写share.success这个方法，android会报错');
    };
    // App中版本没有做向下兼容，导致会使用image_base64的url做分享图片
    if (options.type === 'picture') {
        const appinfo = bbtNative.appinfo;
        if (appinfo.id === 'pregnancy' &&
            appinfo.version &&
            parseInt(appinfo.version.replace(/\./g, ''), 10) >= 764) {
            share.image_base64 = '';
        }
        share.share_source = options.source || 'webview';
        share.share_type = 'shareSinglePicture';
        share.image_data_base64 = options.imageBase64.replace(/^data:image\/(?:jpeg|jpg|png|gif);base64,/, '');
    }
    window.share = share;
    console.log(window.share);
}
export default setShareContent;
